import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-white" data-id="element-75">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-76">
        <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8 md:p-10 border border-pink-100 text-center" data-id="element-77">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-md text-pink-600 mb-6" data-id="element-78">
            <Shield className="w-10 h-10" data-id="element-79" />
          </div>
          <span className="inline-block bg-pink-100 text-pink-800 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest mb-3" data-id="element-80">
            Garantía 7 días
          </span>
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-navy-900 mb-4 uppercase tracking-tight" data-id="element-81">
            Garantía de satisfacción
          </h3>
          <p className="text-slate-700 mb-3" data-id="element-82">
            Queremos que estés{' '}
            <span className="font-semibold" data-id="element-83">100% conforme</span> con tu compra.
          </p>
          <p className="text-slate-600" data-id="element-84">
            Probalo sin riesgo. Si sentís que no era lo que esperabas, podés
            pedir la devolución.
          </p>
          <p className="mt-4 font-bold text-navy-900" data-id="element-85">
            Comprá con tranquilidad: tu inversión está protegida.
          </p>
        </div>
      </div>
    </section>;
}